import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap, tap } from 'rxjs/operators';

import * as actions from '@appStore/customers/actions';
import {
  CustomerManagerCompaniesActionTypes,
  CustomerManagerCompaniesLoadData
} from '@appStore/customers/actions/customer-manager-companies.actions';
import { CustomerService } from '@appStore/customers/services';
import { Router } from '@angular/router';

@Injectable()
export class CustomerManagerCompaniesEffects {
  constructor(private customerService: CustomerService, private actions$: Actions, private router: Router) {}

  loadMyCustomerManagerCompanies$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomerManagerCompaniesActionTypes.CustomerManagerCompaniesLoadData),
      exhaustMap((action: CustomerManagerCompaniesLoadData) => {
        return this.customerService.getMyCustomerManagerCompanies(action.payload.customerId).pipe(
          map(customers => new actions.CustomerManagerCompaniesLoadSuccess(customers)),
          catchError(error => of(new actions.CustomerManagerCompaniesLoadFail(error)))
        );
      })
    );
  });

  createCustomerManagerCompany$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomerManagerCompaniesActionTypes.CreateCustomerManagerCompany),
      map((action: actions.CreateCustomerManagerCompany) => action.payload),
      exhaustMap(input =>
        this.customerService.createCustomerManagerCompany(input).pipe(
          map(output => new actions.CreateCustomerManagerCompanySuccess(output)),
          catchError(error => of(new actions.CreateCustomerManagerCompanyFail(error)))
        )
      )
    );
  });

  deleteCustomerManagerCompany$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomerManagerCompaniesActionTypes.DeleteCustomerManagerCompany),
      map((action: actions.DeleteCustomerManagerCompany) => action.payload),
      exhaustMap(item =>
        this.customerService.deleteCustomerManagerCompany(item).pipe(
          map(() => new actions.DeleteCustomerManagerCompanySuccess(item)),
          catchError(error => of(new actions.DeleteCustomerManagerCompanyFail(error)))
        )
      )
    );
  });
  
  updateCustomerManagerCompany$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CustomerManagerCompaniesActionTypes.UpdateCustomerManagerCompany),
      map((action: actions.UpdateCustomerManagerCompany) => action.payload),
      exhaustMap(item =>
        this.customerService.updateCustomerManagerCompany(item).pipe(
          map(() => new actions.UpdateCustomerManagerCompanySuccess(item)),
          catchError(error => of(new actions.UpdateCustomerManagerCompanyFail(error)))
        )
      )
    );
  });
}
